import { useLoaderData } from "react-router-dom";
import { QuizCart } from "../QuizCart/QuizCart";
import Header from '../Header/Header'

export const Home = () => {
    const quizs = useLoaderData()
    const quizData = quizs.data
    const href = window.location.href
    const url = (href.split('/'))
    const lastUrl = url[url.length - 1]
    console.log(lastUrl)
    let hidden = [];
    if (lastUrl === 'home') {
        hidden.push('hidden')
    }

    return (
        <div>
            <div className={hidden}>
                <Header />
            </div>
            <div className="bg-gray-800 h-full">
                <div className="relative px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
                    <div className="absolute inset-x-0 top-0 items-center justify-center hidden overflow-hidden md:flex md:inset-y-0">
                        <svg
                            viewBox="0 0 88 88"
                            className="w-full max-w-screen-xl text-indigo-100"
                        >
                            <circle fill="currentColor" cx="44" cy="44" r="15.5" />
                            <circle
                                fillOpacity="0.2"
                                fill="currentColor"
                                cx="44"
                                cy="44"
                                r="44"
                            />
                            <circle
                                fillOpacity="0.2"
                                fill="currentColor"
                                cx="44"
                                cy="44"
                                r="37.5"
                            />
                            <circle
                                fillOpacity="0.3"
                                fill="currentColor"
                                cx="44"
                                cy="44"
                                r="29.5"
                            />
                            <circle
                                fillOpacity="0.3"
                                fill="currentColor"
                                cx="44"
                                cy="44"
                                r="22.5"
                            />
                        </svg>
                    </div>
                    <div className="relative grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
                        {
                            quizData.map(quiz => <QuizCart key={quiz.id} quiz={quiz} />)
                        }
                    </div>
                </div>
            </div>
        </div>

    );
};